module.exports = __webpack_public_path__ + "img/icon7.0fefa311.png";